import { DemoMode, MousedOverTextHelper } from "../../state/uiAtoms";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { IsInPortrait } from "../../state/selectors";
import { TopBarControl } from "../StyledControl";
import { text } from "@quickpoint.me/shared";

function SignInFromDemoControl() {
	const setTextHelper = useSetRecoilState(MousedOverTextHelper);
	const isInPortrait = useRecoilValue(IsInPortrait);
	const setDemoMode = useSetRecoilState(DemoMode);

	const signInFromDemo = () => {
		setDemoMode(false);
	};

	const mouseOver = () => {
		setTextHelper(text.ui.signInToSave);
	};

	const mouseLeave = () => {
		setTextHelper(undefined);
	};

	if (isInPortrait) return null;

	return (
		<TopBarControl
			$isInPortrait={isInPortrait}
			onClick={signInFromDemo}
			onMouseOver={mouseOver}
			onMouseLeave={mouseLeave}
			className="top-bar-control sign-in"
		>
			{text.ui.signIn}
		</TopBarControl>
	);
}

export default SignInFromDemoControl;
